// extracted by mini-css-extract-plugin
module.exports = {"apiBaseInfo":"APIInfo_apiBaseInfo__c0leR","labelName":"APIInfo_labelName__TzFiL","labelInfo":"APIInfo_labelInfo__BD0wx"};